import { ApplicationEntity } from "@/entities/ApplicationEntity.js";
import { apiRequest } from "@/services/api/apiClient.js";

const entity = new ApplicationEntity();

/**
 * Registry de aplicacoes da plataforma, na API do liberty/auth.
 *
 * Nao confundir com `services/api/apps.js`: la fica o `GET /apps`, que devolve
 * o que **este usuario** pode abrir e alimenta o menu. Aqui e a administracao
 * do cadastro em si.
 */
export async function getApplications({ page = 1, limit = 10, ...filters } = {}) {
    return apiRequest({
        client: window.API_AUTH,
        method: "get",
        url: entity.endpoints.list,
        params: { page, limit, ...filters },
    });
}

export async function getApplicationById({ id }) {
    return apiRequest({
        client: window.API_AUTH,
        method: "get",
        url: entity.getUrl(entity.endpoints.get, { id }),
    });
}

/**
 * O `slug` nao vai no update: a API recusa troca, porque ele identifica a
 * aplicacao nos tokens ja emitidos para ela.
 */
export async function saveApplication(data) {
    const isUpdate = !!data.id;
    const { id, slug, ...campos } = data;

    return apiRequest({
        client: window.API_AUTH,
        method: isUpdate ? "put" : "post",
        url: isUpdate
            ? entity.getUrl(entity.endpoints.get, { id })
            : entity.endpoints.create,
        body: isUpdate ? campos : { ...campos, slug },
    });
}

export async function deleteApplication({ id }) {
    return apiRequest({
        client: window.API_AUTH,
        method: "delete",
        url: entity.getUrl(entity.endpoints.delete, { id }),
    });
}

/**
 * Servicos cadastrados, para escolher quem enxerga a aplicacao. E a mesma
 * lista que o `PermService` usa para decidir permissao.
 */
export async function listServices({ name = null, page = 1, limit = 50 } = {}) {
    const response = await apiRequest({
        client: window.API_AUTH,
        method: "get",
        url: "service",
        params: name ? { name: `%${name}%`, page, limit } : { page, limit },
    });

    return response?.data ?? [];
}

/**
 * Enderecos de uma aplicacao.
 *
 * Esta tabela e a allowlist de destino do SSO: o auth so redireciona para uma
 * URL registrada aqui. Por isso `url` guarda apenas a origem (esquema, host e
 * porta) -- a API recusa caminho, query ou fragmento, para que a comparacao do
 * destino seja exata.
 *
 * `environment` e `corp_id` vazios valem para todos: e o que permite um mesmo
 * cadastro servir dev e producao, e uma URL propria por cliente quando houver.
 */
export async function getApplicationUrls({ id }) {
    const response = await apiRequest({
        client: window.API_AUTH,
        method: "get",
        url: entity.getUrl(entity.endpoints.urls, { id }),
    });

    return response?.data ?? [];
}

export async function saveApplicationUrl({ id, url }) {
    const isUpdate = !!url.id;

    return apiRequest({
        client: window.API_AUTH,
        method: isUpdate ? "put" : "post",
        url: isUpdate
            ? `${entity.getUrl(entity.endpoints.urls, { id })}/${url.id}`
            : entity.getUrl(entity.endpoints.urls, { id }),
        body: {
            url: url.url,
            environment: url.environment || null,
            corp_id: url.corp_id || null,
            is_default: !!url.is_default,
            status: url.status ?? true,
        },
    });
}

export async function deleteApplicationUrl({ id, urlId }) {
    return apiRequest({
        client: window.API_AUTH,
        method: "delete",
        url: `${entity.getUrl(entity.endpoints.urls, { id })}/${urlId}`,
    });
}
